import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoaurangabadcabs() {



  const cardData =
  {
    keyword: ' Pune to Aurangabad Cab',
    heading: 'Sai Trupti Cabs: Pune to Aurangabad Cab',
    headingDescription: 'Sai Trupti Cabs offers comfortable and reliable Pune to Aurangabad cab services, ideal for both leisure and business travelers seeking a smooth, hassle-free ride. Our fleet of well-maintained, air-conditioned Sedans, SUVs-and larger vehicles ensures a relaxing journey from Pune to Aurangabad and surrounding areas. With experienced, background-verified chauffeurs, we guarantee punctual pick-ups, courteous service, and safe driving throughout the trip. Whether you’re travelling one-way or on a round trip, our transparent pricing, flexible booking options, and 24×7 customer support make your Sulthanate journey stress-free. Experience seamless and enjoyable travel from Pune to Aurangabad with Sai Trupti Cabs—your trusted partner for dependable and comfortable inter-city cab services.',

    top: 'Top Places to Visit in Aurangabad with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, a UNESCO World Heritage Site, are a magnificent series of 30 rock-cut Buddhist monuments carved into a horseshoe-shaped cliff along the Waghora River. Dating back to the 2nd century B.C., these caves are adorned with exquisite frescoes, murals, and sculptures that depict the life of Buddha and tales from the Jataka. The paintings still glow with natural pigments even after centuries. Surrounded by tranquil greenery, Ajanta stands as a timeless masterpiece of ancient art, faith, and craftsmanship."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO marvel near Aurangabad, showcase an extraordinary fusion of Hindu, Buddhist, and Jain architecture carved between the 6th and 10th centuries. The highlight is the Kailasa Temple (Cave 16), a single monolithic structure carved from solid basalt rock to represent Mount Kailash. With over 100 caves, of which 34 are open to visitors, Ellora reflects India’s unity in diversity. Its sheer scale, intricate carvings, and spiritual energy make it one of the world’s greatest archaeological wonders."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Often called the ‘Mini Taj Mahal’, Bibi Ka Maqbara was built by Prince Azam Shah in memory of his mother, Dilras Banu Begum. The white-marble mausoleum, set against the backdrop of the hills, closely resembles the Taj Mahal yet holds a distinct Deccan charm. Beautifully landscaped gardens, ornamental fountains, and symmetrical pathways enhance its regal beauty. As the evening light turns golden, the monument glows with serene elegance, making it one of Aurangabad’s most photographed and romantic landmarks."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Perched on a conical hill, Daulatabad Fort is one of the strongest medieval citadels of India, located about 15 km from Aurangabad. Built in the 12th century, the fort features massive stone walls, a deep moat, and a complex defense system designed to repel invaders. The famous ‘Chand Minar’ and rock-cut passages add to its architectural brilliance. A climb to the top rewards visitors with panoramic views of the Deccan plateau, making Daulatabad a thrilling blend of history, adventure, and grandeur."
  },
  {
    "title": "Panchakki (Water Mill)",
    "description": "Panchakki, meaning ‘water wheel’, is a 17th-century engineering marvel that once powered grinding mills using an underground water channel. Built during the Mughal era to serve a Sufi shrine, the site houses a tranquil garden, mosque, and a fish-filled pond reflecting the ancient architecture. The rhythmic sound of flowing water and the cool atmosphere offer a soothing escape from the city bustle. Panchakki beautifully combines science, spirituality, and nature in one harmonious setting."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Located just a few kilometers from Ellora Caves, Grishneshwar Jyotirlinga is one of the twelve holiest shrines dedicated to Lord Shiva. Rebuilt in the 18th century, the temple’s red-sandstone architecture, intricate carvings, and tall shikhara reflect Maratha grandeur. Devotees believe that a visit here completes the Jyotirlinga Yatra. The chants of ‘Om Namah Shivaya’ echo through the temple’s sacred halls, filling the air with divine energy and making it an essential spiritual stop near Aurangabad."
  },
  {
    "title": "Aurangabad Caves",
    "description": "The Aurangabad Caves are a lesser-known gem carved between the 6th and 8th centuries into the Sihyachal Range. These 12 rock-cut Buddhist caves feature remarkable sculptures of Bodhisattvas, ornate chaityas, and vihara halls. Overlooking the city and the Bibi Ka Maqbara, they offer both panoramic views and spiritual serenity. The artistry here shows a transition from early Buddhist simplicity to mature Indian craftsmanship, making it a hidden treasure for history and art enthusiasts."
  },
  {
    "title": "Salim Ali Lake and Bird Sanctuary",
    "description": "Named after the famous ornithologist Dr. Salim Ali, this scenic lake and bird sanctuary provide a green haven within Aurangabad. It’s home to numerous resident and migratory bird species, making it a paradise for nature lovers and photographers. The calm waters, lush surroundings, and chirping birds create a refreshing retreat. Visitors often enjoy boating and leisurely walks, especially during winter when the sanctuary is alive with colorful avian guests from across continents."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "description": "Located near the central bus stand, Siddharth Garden is one of Aurangabad’s most popular recreational spaces. Spread across acres of manicured lawns, flowerbeds, and shaded trees, it also houses a small zoo that delights families and children alike. The view of Bibi Ka Maqbara’s dome from the garden adds to its charm. Whether for picnics or evening strolls, Siddharth Garden provides a refreshing escape in the heart of the city."
  },
  {
    "title": "Soneri Mahal",
    "description": "Soneri Mahal, meaning ‘Golden Palace’, is an elegant two-storied structure located at the foothills of the Aurangabad Caves. Built in the 17th century by a Bandalkar commander, the palace once housed golden paintings that gave it its name. Today it serves as a museum displaying ancient artifacts, coins, and art from the Mughal and Maratha periods. The surrounding garden and its heritage architecture make Soneri Mahal a must-visit for history enthusiasts exploring the royal legacy of Aurangabad."
  }
],



"services": [
    {
      "name": "Pune to Aurangabad Cab",
      "description": "Reliable cab service from Pune to Aurangabad offering spacious and comfortable vehicles for solo travelers, families, and groups. The service includes professional drivers who ensure a safe and timely journey, AC and non-AC options, and flexible scheduling. Ideal for leisure trips, business travel, or sightseeing tours, this cab service provides door-to-door pickup, real-time tracking, well-maintained vehicles, and transparent fares, making your journey from Pune to Aurangabad stress-free and enjoyable."
    },
    {
      "name": "Pune to Aurangabad Taxi",
      "description": "Convenient taxi service from Pune to Aurangabad with multiple vehicle options including Sedans, SUVs, and luxury cars. Perfect for travelers looking for one-way or round trips, with AC and non-AC options. Professional drivers ensure punctuality, comfort, and safety, making it an excellent choice for both business commuters and family trips, while offering hassle-free travel, easy online booking, and flexible drop points."
    },
    {
      "name": "Pune to Aurangabad Car Hire",
      "description": "Car hire service from Pune to Aurangabad offering a wide range of vehicles including Sedans, SUVs, and luxury cars for personalized travel. Ideal for corporate travel, sightseeing tours, or family trips, the service includes professional drivers, AC/non-AC options, and customizable pickup and drop locations. Enjoy a comfortable, secure, and convenient journey with well-maintained vehicles and transparent fare structures."
    },
    {
      "name": "Pune to Aurangabad Innova Cab",
      "description": "Travel from Pune to Aurangabad in a spacious and comfortable Innova cab, perfect for families or small groups. This service includes AC vehicles, professional drivers, door-to-door pickup, and flexible travel timings. Ideal for long-distance journeys, sightseeing trips, and pilgrimage visits, the Innova cab ensures a smooth, safe, and relaxing ride with modern amenities and transparent pricing."
    },
    {
      "name": "Pune to Aurangabad Ertiga Cab",
      "description": "Ertiga cab service from Pune to Aurangabad designed for small to medium groups, offering comfortable seating, AC service, and professional drivers. Suitable for family trips, leisure travel, and sightseeing tours, the service provides safe, reliable, and stress-free transport with options for one-way or round trips. Real-time tracking, well-maintained vehicles, and easy online booking make this journey hassle-free and enjoyable."
    },
    {
      "name": "Pune to Aurangabad Sedan Cab",
      "description": "Sedan cab service from Pune to Aurangabad providing a smooth, comfortable ride for business travelers, couples, or solo passengers. Equipped with AC and luxury amenities, the service includes professional drivers, safe travel, and flexible scheduling. Perfect for airport transfers, city tours, or long-distance travel, ensuring a convenient, stress-free, and pleasant journey."
    },
    {
      "name": "Pune to Aurangabad One Way Taxi",
      "description": "Affordable one-way taxi service from Pune to Aurangabad, ideal for travelers seeking direct and efficient transport. Professional drivers ensure punctual pickups, safe travel, and comfortable vehicles, with AC and non-AC options. The service is perfect for business trips, family visits, or leisure travel, providing hassle-free, reliable, and stress-free transportation."
    },
    {
      "name": "Pune to Aurangabad Drop Cab",
      "description": "Drop cab service from Pune to Aurangabad providing point-to-point travel with AC and non-AC vehicles. Professional drivers ensure a safe, comfortable, and timely journey, ideal for long-distance trips, sightseeing tours, or pilgrimage travel. Flexible drop points, well-maintained vehicles, and transparent fares make it a convenient choice for all types of travelers."
    },
    {
      "name": "Pune to Aurangabad Luxury Cab",
      "description": "Premium luxury cab service from Pune to Aurangabad with top-class vehicles and professional chauffeurs. Equipped with AC, comfortable seating, and optional amenities, the service ensures a high-end, stress-free journey for business executives, couples, or families. Ideal for airport transfers, sightseeing tours, and long-distance travel, providing safety, punctuality, and personalized service."
    },
    {
      "name": "Pune to Aurangabad Outstation Cab",
      "description": "Outstation cab service from Pune to Aurangabad offering long-distance travel with professional drivers, well-maintained vehicles, and comfortable seating. Includes tolls, driver allowances, and flexible scheduling. Ideal for families, group travel, and business trips, ensuring safe, timely, and hassle-free transportation with door-to-door convenience and AC options."
    },
    {
      "name": "Affordable Pune to Aurangabad Cab",
      "description": "Budget-friendly cab service from Pune to Aurangabad providing AC and non-AC vehicles for cost-effective travel. Professional drivers ensure safety, punctuality, and comfort for families, groups, or solo travelers. Transparent fare options and flexible booking make it a reliable choice for those seeking affordable yet high-quality transport."
    },
    {
      "name": "Pune to Aurangabad AC Cab",
      "description": "AC cab service from Pune to Aurangabad offering a cool and comfortable ride for long-distance travel. Equipped with professional drivers and modern vehicles, this service ensures safety, punctuality, and a smooth journey. Ideal for families, business trips, and leisure travel, with flexible scheduling and door-to-door convenience."
    },
    {
      "name": "Pune to Aurangabad Online Booking",
      "description": "Book your Pune to Aurangabad cab online with multiple vehicle options, secure payments, and transparent fares. This service provides hassle-free booking for one-way or round trips, ensuring punctual pickups, professional drivers, and safe travel. Ideal for families, groups, or solo travelers seeking convenience and reliable transportation."
    },
    {
      "name": "Pune to Aurangabad Travel Service",
      "description": "Comprehensive travel service from Pune to Aurangabad including cabs, drop services, luxury options, and professional drivers. Perfect for leisure trips, business travel, and group journeys, the service ensures a comfortable, stress-free, and safe travel experience with flexible booking and well-maintained vehicles."
    },
    {
      "name": "Pune to Aurangabad Cab near Me",
      "description": "Find Pune to Aurangabad cabs near your location for quick and convenient booking. The service provides professional drivers, AC and non-AC vehicles, luxury options, and reliable transportation for families, groups, and solo travelers, ensuring a hassle-free journey from your doorstep to Aurangabad."
    }
  ],
  "tableData": [
    ["Pune to Aurangabad Cab", "Pune to Aurangabad Taxi"],
    ["Pune to Aurangabad Car Hire", "Pune to Aurangabad Innova Cab"],
    ["Pune to Aurangabad Ertiga Cab", "Pune to Aurangabad Sedan Cab"],
    ["Pune to Aurangabad One Way Taxi", "Pune to Aurangabad Drop Cab"],
    ["Pune to Aurangabad Luxury Cab", "Pune to Aurangabad Outstation Cab"],
    ["Affordable Pune to Aurangabad Cab", "Pune to Aurangabad AC Cab"],
    ["Pune to Aurangabad Online Booking", "Pune to Aurangabad Travel Service"],
    ["Pune to Aurangabad Cab near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Aurangabad Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable cab services from Pune to Aurangabad—ideal for business travel, sightseeing trips or one-way transfers."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one‑way fares from Pune to Aurangabad start from approx. ₹2,600 (for hatchbacks) to around ₹3,300 (for sedans) depending on vehicle type. :contentReference[oaicite:8]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Pune to Aurangabad route. :contentReference[oaicite:5]{index=2}"
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers are familiar with the Pune‑to‑Aurangabad route, ensuring a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups anywhere in Pune (city, airport, suburbs) and drop‑offs in Aurangabad (city centre, station, hotel)."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized and maintained to ensure comfort and reliability on the longer drive from Pune to Aurangabad."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route planning or any travel changes for your Pune‑to‑Aurangabad cab."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Aurangabad cab easily via call, WhatsApp or our website—with instant confirmation and prompt vehicle dispatch."
  }
]






































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Aurangabad cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable cab services from Pune to Aurangabad for one way, round trip, and group travel.',
  },
  {
    question: 'How can I book a cab from Pune to Aurangabad with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Aurangabad cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Aurangabad?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Aurangabad trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune to Aurangabad for family or group trips?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and business travel from Pune to Aurangabad.',
  },
  {
    question: 'Is the Pune to Aurangabad cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pune to Aurangabad for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune to Aurangabad cab fares?',
    answer: 'Our cab fares start from ₹2,500 for sedans, ₹3,000–₹4,000 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Aurangabad cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Aurangabad cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Pune to Aurangabad cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Aurangabad cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Deshmukh',
    feedback: 'Booking a Pune to Aurangabad cab with Sai Trupti Cabs was seamless. The driver was punctual and the journey was smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Rane',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Aurangabad trip. Comfortable cab and very professional driver.',
    rating: 5,
  },
];

































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Aurangabad Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Pune to Aurangabad Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-aurangabad-cab"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune to Aurangabad Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Aurangabad Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to Aurangabad Cab, Pune to Aurangabad Taxi, Pune to Aurangabad Car Hire, Pune to Aurangabad Innova Cab, Pune to Aurangabad Ertiga Cab, Pune to Aurangabad Sedan Cab, Pune to Aurangabad One Way Taxi, Pune to Aurangabad Drop Cab, Pune to Aurangabad Luxury Cab, Pune to Aurangabad Outstation Cab, Affordable Pune to Aurangabad Cab, Pune to Aurangabad AC Cab, Pune to Aurangabad Online Booking, Pune to Aurangabad Travel Service, Pune to Aurangabad Cab near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoaurangabadcabs;